import { SectionShell } from "../components/home/SectionShell";
import { SectionTitle } from "../components/home/SectionTitle";
import { RaceDetailsTable } from "../components/home/RaceDetailsTable";

const raceDetailsBlocks = [
  {
    title: "Batch 04:00 (Sabtu)",
    rows: [
      {
        category: "24H INDIVIDU",
        line: "Line 2,3",
        start: "Day 1 · 04:00",
        cot: "Day 2 · 04:00",
        duration: "24 Hours",
      },
    ],
  },
  {
    title: "Batch 05:00 (Sabtu)",
    rows: [
      {
        category: "42K INDIVIDU",
        line: "Line 6,7,8",
        start: "Day 1 · 05:00",
        cot: "Day 1 · 12:00",
        duration: "7 Hours",
      },
      {
        category: "50K INDIVIDU",
        line: "Line 6,7,8",
        start: "Day 1 · 05:00",
        cot: "Day 1 · 13:00",
        duration: "8 Hours",
      },
      {
        category: "100K INDIVIDU",
        line: "Line 6,7,8",
        start: "Day 1 · 05:00",
        cot: "Day 1 · 21:00",
        duration: "16 Hours",
      },
      {
        category: "RELAY 50K",
        line: "Line 6,7,8",
        start: "Day 1 · 05:00",
        cot: "Day 1 · 13:00",
        duration: "8 Hours",
      },
      {
        category: "RELAY 100K",
        line: "Line 6,7,8",
        start: "Day 1 · 05:00",
        cot: "Day 1 · 21:00",
        duration: "16 Hours",
      },
    ],
  },
  {
    title: "Batch 16:00 (Sabtu)",
    rows: [
      {
        category: "6H INDIVIDU",
        line: "Line 4,5",
        start: "Day 1 · 16:00",
        cot: "Day 1 · 22:00",
        duration: "6 Hours",
      },
      {
        category: "12H INDIVIDU",
        line: "Line 4,5",
        start: "Day 1 · 16:00",
        cot: "Day 2 · 04:00",
        duration: "12 Hours",
      },
    ],
  },
  {
    title: "Fun Run (Minggu)",
    rows: [
      {
        category: "10K",
        line: "Race Venue",
        start: "Day 2 · 05:30",
        cot: "Day 2 · 07:30",
        duration: "2 Hours",
      },
      {
        category: "5K",
        line: "Race Venue",
        start: "Day 2 · 06:00",
        cot: "Day 2 · 07:00",
        duration: "1 Hour",
      },
    ],
  },
];

export const Ultra24RaceTableSection = () => {
  return (
    <SectionShell id="race-details-table" className="bg-white">
      <SectionTitle
        title="Rincian Start, COT, dan Durasi"
        subtitle="Rincian ini diselaraskan dengan jadwal resmi event Ultra24 Agustus 2026."
        align="center"
      />
      <RaceDetailsTable blocks={raceDetailsBlocks} />
    </SectionShell>
  );
};
